import router from '@/router'

function getRandomInt (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function shuffle (arr) {
  let _arr = arr.slice()
  for (let i = 0; i < _arr.length; i++) {
    let j = getRandomInt(0, i)
    let t = _arr[i]
    _arr[i] = _arr[j]
    _arr[j] = t
  }
  return _arr
}

/**
 * 禁止click连续点击
 */
export function debounceClick (func, delay) {
  let timer
  let flag = false
  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      flag = false
    }, delay)
    if (flag === true) {
      return false
    }
    flag = true
    func.apply(this, args)
  }
}

/**
 * 消抖函数
 * @param func
 * @param delay
 * @returns {Function}
 */
export function debounce (func, delay) {
  let timer
  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export function isEmptyObject (e) {
  let t
  for (t in e) {
    return !1
  }
  return !0
}

/**
 * json深拷贝
 * @param data
 * @returns {Array}
 */
export function jsonArrayDeepCopy (data) {
  let newData = []
  for (let i = 0; i < data.length; ++i) {
    newData.push(JSON.parse(JSON.stringify(data[i])))
  }
  return newData
}

/**
 * 获取当前时间戳
 */
export function getNow () {
  const nowTimestamp = Date.parse(new Date()) / 1000
  return nowTimestamp
}

/**
 * 获取当前时间 最小单位毫秒
 */
export function getNowTime () {
  const nowTimestamp = Date.parse(new Date())
  return nowTimestamp
}

export function timestampToDate (timestamp) {
  let date = new Date(timestamp)
  let month = date.getMonth() + 1
  month = month < 10 ? `0${month}` : month
  let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  return `${date.getFullYear()}-${month}-${day}`
}

export function getCountDays () {
  let curDate = new Date()
  /* 获取当前月份 */
  let curMonth = curDate.getMonth()
  /*  生成实际的月份: 由于curMonth会比实际月份小1, 故需加1 */
  curDate.setMonth(curMonth + 1)
  /* 将日期设置为0, 这里为什么要这样设置, 我不知道原因, 这是从网上学来的 */
  curDate.setDate(0)
  /* 返回当月的天数 */
  return curDate.getDate()
}

export function getWeek (dateString) {
  let date
  if (!dateString) {
    date = new Date()
  } else {
    var dateArray = dateString.split('-')
    date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2])
  }
  return '0123456'.charAt(date.getDay())
}

/**
 * 时间戳赚时间   几小时前   日期
 * @param timestamp
 * @returns {string}
 */
export function timeToStr (timestamp) { // 时间戳转帖子显示的事件
  timestamp = timestamp / 1000
  const nowTimestamp = Date.parse(new Date()) / 1000 + 60
  let s = nowTimestamp - timestamp
  let h = Math.floor(s / 3600)
  if (h < 13) {
    if (h === 0) {
      return `${Math.floor(s / 60)}分钟前`
    } else {
      return `${h}小时前`
    }
  }
  let date = new Date(timestamp * 1000)
  let min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
  let nowDate = new Date(nowTimestamp * 1000)
  if (date.getFullYear() === nowDate.getFullYear() && date.getMonth() === nowDate.getMonth() && date.getDate() === nowDate.getDate()) {
    return `${date.getHours()}:${min}`
  }
  if (date.getFullYear() === nowDate.getFullYear() && date.getMonth() === nowDate.getMonth() && (date.getDate() + 1) === nowDate.getDate()) {
    return `昨天${date.getHours()}:${min}`
  }
  return `${date.getMonth() + 1}-${date.getDate()}`
}

/**
 * 时间戳2时间
 * @param timestamp
 * @returns {string}
 */
export function timeToStr2 (timestamp) { // 时间戳转帖子显示的事件
  timestamp = timestamp / 1000
  let date = new Date(timestamp * 1000)
  let year = date.getFullYear()
  let min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
  return `${year}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${min}`
}

export function timeToStr3 (timestamp) { // 时间戳转帖子显示的事件
  timestamp = timestamp / 1000
  let date = new Date(timestamp * 1000)
  let year = date.getFullYear()
  let min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
  return `${year}-${date.getMonth() + 1}-${date.getDate()}`
}

/**
 * 聊天中的时间戳转时间
 * @param timestamp
 * @returns {string}
 */
export function chatTimeToStr (timestamp) { // 时间戳转帖子显示的事件
  const nowTimestamp = Date.parse(new Date()) / 1000
  let date = new Date(timestamp * 1000)
  let nowDate = new Date(nowTimestamp * 1000)
  let min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
  if (date.getFullYear() === nowDate.getFullYear() && date.getMonth() === nowDate.getMonth() && date.getDate() === nowDate.getDate()) {
    return `${date.getHours()}:${min}`
  }
  if (date.getFullYear() === nowDate.getFullYear() && date.getMonth() === nowDate.getMonth() && (date.getDate() + 1) === nowDate.getDate()) {
    return `昨天${date.getHours()}:${min}`
  }
  return `${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${min}`
}

export function isToday (timestamp) { // 判断是否是今天
  const nowTimestamp = Date.parse(new Date()) / 1000
  let date = new Date(timestamp * 1000)
  let nowDate = new Date(nowTimestamp * 1000)
  if (nowDate.getYear() === date.getYear() && nowDate.getMonth() === date.getMonth() && nowDate.getDate() === date.getDate()) {
    return true
  }
  return false
}

export function sexToTime (s) {
  let hour = Math.floor(s / 3600)
  let min = Math.floor(s / 60) % 60
  let sec = Math.floor(s % 60)
  let tmp = {
    hour,
    min,
    sec
  }
  return tmp
}

/**
 * 获取dom样式
 * @param obj
 * @param attr
 * @returns {*}
 */
export function getStyle (obj, attr) {
  if (obj.currentStyle) {
    return obj.currentStyle[attr]
  } else {
    return document.defaultView.getComputedStyle(obj, null)[attr]
  }
}

/**
 * 根据时间戳返回星座
 * @param timestamp
 */
export function getConstellation (timestamp) {
  const timer = new Date(timestamp)
  const month = timer.getMonth() + 1
  const date = timer.getDate()
  let value = '白羊座'
  if ((month === 1 && date >= 20) || (month === 2 && date <= 18)) {
    value = '水瓶座'
  }
  if ((month === 2 && date >= 19) || (month === 3 && date <= 20)) {
    value = '双鱼座'
  }
  if ((month === 3 && date >= 21) || (month === 4 && date <= 19)) {
    value = '白羊座'
  }
  if ((month === 4 && date >= 20) || (month === 5 && date <= 20)) {
    value = '金牛座'
  }
  if ((month === 5 && date >= 21) || (month === 6 && date <= 21)) {
    value = '双子座'
  }
  if ((month === 6 && date >= 22) || (month === 7 && date <= 22)) {
    value = '巨蟹座'
  }
  if ((month === 7 && date >= 23) || (month === 8 && date <= 22)) {
    value = '狮子座'
  }
  if ((month === 8 && date >= 23) || (month === 9 && date <= 22)) {
    value = '室女座'
  }
  if ((month === 9 && date >= 23) || (month === 10 && date <= 22)) {
    value = '天秤座'
  }
  if ((month === 10 && date >= 23) || (month === 11 && date <= 21)) {
    value = '天蝎座'
  }
  if ((month === 11 && date >= 22) || (month === 12 && date <= 21)) {
    value = '人马座'
  }
  if ((month === 12 && date >= 22) || (month === 1 && date <= 19)) {
    value = '摩羯座'
  }
  return value
}

/**
 * 获取称号
 * @param user
 * @returns {*}
 */
export function getDesignation (user) {
  if (user.gender === 1) {
    return user.memberGrade.boyName
  } else {
    return user.memberGrade.girlName
  }
}

/**
 * 获取下一级升级所需要的经验
 * @param user
 * @returns {number}
 */
export function getNextLevelExp (table, user, exp) {
  if (table.length > 0) {
    for (let i = 0; i < table.length; ++i) {
      if (table[i].name === user.memberGrade.name) {
        if (table[i + 1]) {
          return {
            nextNeedExp: table[i + 1].exp - exp,
            nextExp: table[i + 1].exp,
            preLevelExp: table[i].exp,
            nextLevelName: table[i + 1].name
          }
        } else {
          return {
            nextNeedExp: 0,
            nextExp: 0,
            preLevelExp: 0,
            nextLevelName: ''
          }
        }
      }
    }
    return {
      nextNeedExp: 0,
      nextExp: 0,
      preLevelExp: 0,
      nextLevelName: ''
    }
  } else {
    return {
      nextNeedExp: 0,
      nextExp: 0,
      preLevelExp: 0,
      nextLevelName: ''
    }
  }
}

/**
 * 根据时间戳获取年龄
 * @param timestamp
 * @returns {number}
 */
export function getAge (timestamp) {
  const nowTimestamp = Date.parse(new Date()) / 1000
  let date = new Date(timestamp)
  let nowDate = new Date(nowTimestamp * 1000)
  return (nowDate.getFullYear() - date.getFullYear())
}

export function dataURLtoBlob (dataurl) {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], {type: mime})
}

// 判断元素是否在数组里
export function inArray (needle, haystack) {
  if (!haystack) {
    return false
  }
  let n = haystack.length
  for (let i = 0; i < n; ++i) {
    if (haystack[i] === needle) {
      return true
    }
  }
  return false
}

export function filterTag (str) {
  if (!str) {
    return str
  }
  return str.replace(/(<\/?li.*?>)/g, '').replace(/(<\/?a.*?>)/g, '').replace(/(<\/?table.*?>)/g, '').replace(/(<\/?div.*?>)/g, '').replace(/(<\/?ul.*?>)/g, '')
}

export function html2Escape (sHtml) {
  return sHtml.replace(/[<>&"]/g, function (c) {
    return {
      '<': '&lt;',
      '>': '&gt;',
      '&': '&amp;',
      '"': '&quot;'
    }[c]
  })
}

export function copy (str) { // 复制到剪贴板
  let save = function (e) {
    e.clipboardData.setData('text/plain', str)// 下面会说到clipboardData对象
    e.preventDefault()// 阻止默认行为
  }
  document.addEventListener('copy', save)
  document.execCommand('copy')// 使文档处于可编辑状态，否则无效
}

export function openUrl (item) {
  let url = ''
  if (item.type && item.type.enum === 'PRODUCT') {
    const productId = item.contentId
    // router.push('/shop/details?productId=' + productId)
    const newPage = router.resolve('/shop/details?productId=' + productId)
    window.open(newPage.href, '_blank')
    return true
  }
  if (item.type && item.type.enum === 'ARTICLE') {
    const articleId = item.contentId
    // router.push('/article?articleId=' + articleId)
    const newPage = router.resolve('/article?articleId=' + articleId)
    window.open(newPage.href, '_blank')
    return true
  }
  if (item.type && item.type.enum === 'POST') {
    const postId = item.contentId
    // router.push('/post?postId=' + postId)
    const newPage = router.resolve('/post?postId=' + postId)
    window.open(newPage.href, '_blank')
    return true
  }
  if (item.type && item.type.enum === 'POST_TOPIC') {
    const topicId = item.contentId
    // router.push('/details-theme?topicId=' + topicId)
    const newPage = router.resolve('/details-theme?topicId=' + topicId)
    window.open(newPage.href, '_blank')
    return true
  }
  if (item.type && (item.type.enum === 'ARTICLE_TAG')) {
    const tagId = item.contentId
    // router.push('/article-label?articleTagId=' + tagId)
    const newPage = router.resolve('/article-label?articleTagId=' + tagId)
    window.open(newPage.href, '_blank')
    return true
  }
  if (item.type && (item.type.enum === 'POST_TOPIC_TAG')) {
    const tagId = item.contentId
    // router.push('/tag-theme?tagId=' + tagId + '&tagName=' + item.name)
    const newPage = router.resolve('/tag-theme?tagId=' + tagId + '&tagName=' + item.name)
    window.open(newPage.href, '_blank')
    return true
  }
  if (item.url) {
    url = item.url
  } else {
    url = item.adUrl
    item.urlTitle = item.title
  }
  if (url) {
    const isHttp = url.substr(0, 4)
    if (isHttp === 'http') {
      // router.push(`/adindex/${encodeURIComponent(url)}/${item.urlTitle}`)
      const newPage = router.resolve(`/adindex/${encodeURIComponent(url)}/${item.urlTitle}`)
      window.open(newPage.href, '_blank')
    } else {
      // router.push({
      //   path: url
      // })
      const newPage = router.resolve({path: url})
      window.open(newPage.href, '_blank')
    }
  }
}

export function isAndroid () {
  try {
    // eslint-disable-next-line no-undef
    if (!isNull(plus)) {
      // eslint-disable-next-line no-undef
      const osName = plus.os.name.toLowerCase()
      return osName === 'android'
    }
  } catch (e) {
    // ignore
  }
}

export function isFullscreenEnabled () {
  return document.fullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.webkitFullscreenEnabled ||
    document.msFullscreenEnabled || false
}

// export function getMsg () {
//   json.post('/member/communication/api/fetch').then((res) => {
//     getMsg()
//     if (res.data.success === false && res.data.msg === '超时') {
//       return 0
//     } else if (res.data.success === false) {
//       this.errorTips = res.data.msg
//       return 0
//     } else {
//       const chats = res.data.data.chat
//       const content = cache.loadMsgList()
//       for (let item of chats) {
//         const msg = {
//           'uid': item.sender.id,
//           'nickname': item.sender.nickname,
//           'avatar': item.sender.avatar,
//           'content': item.content,
//           'createdDate': item.createdDate / 1000
//         }
//         if (isEmptyObject(content[item.sender.id])) {
//           content[item.sender.id] = []
//         }
//         content[item.sender.id].push(msg)
//       }
//       cache.saveMsgList(content)
//       console.log(cache.loadMsgList())
//     }
//   }).catch((err) => {
//     console.log(err)
//   })
// }



// WEBPACK FOOTER //
// ./src/assets/js/util.js